module.exports = __webpack_public_path__ + "9ac0aace11c369151bb1a277dd739959.svg";